import { Params } from "../Slices/ParamSlice"
import Format from "./formatParamOptions"

export const determineScope = (scopeOrder:string,country:string,customer:string,selectedDeviceTypes:any[],selectedDevicesWithSerial:any[]) =>{
    if (scopeOrder === "Customer > Machine"){
        if(selectedDevicesWithSerial.length > 0){
            return "cadid"
        }else if (customer != null){
            return "device"
        }else{
            return "customer"
        }
    }
    if(scopeOrder === "Country > Customer > Machine"){
        if(selectedDevicesWithSerial.length > 0){
            return "cadid"
        }else if(customer !== null){
            return "device"
        }else if(!(country === null || country === "all")){
            return "customer"
        }else{
            return "country"
        }
    }
    if (scopeOrder === "Device Type > Customer > Machine"){
        if(selectedDevicesWithSerial.length > 0){
            return "cadid"
        }else if (customer != null){
            return "device"
        }else if (selectedDeviceTypes.length > 0){
            return "customer"
        }else{
            return "deviceType"
        }
    }
    if (scopeOrder === "Device Type > Country > Customer > Machine"){
        if(selectedDevicesWithSerial.length > 0){
            return "cadid"
        }else if(customer !== null){
            return "device"
        }else if(country !== null && country !== "all"){
            return "customer"
        }else if(selectedDeviceTypes.length > 0){
            return "country"
        }else{
            return "deviceType"
        }
    }
    if (scopeOrder === "Device Type > Machine"){
        if(selectedDevicesWithSerial.length > 0){
            return "cadid"
        }else if(selectedDeviceTypes.length > 0){
            return "device"
        }else{
            return "deviceType"
        }
    }
}

export const paramsById = (params:Params,options:any,deviceObjects:any,id:string) =>{
    let newParams = {...params}
    if (params.scope === "country"){
        newParams.country = id
        newParams.scope = determineScope(options.scopeOrder,newParams.country,newParams.customerID,newParams.deviceTypes,newParams.devicesWithSerial)
        return newParams;
    }else if (params.scope === "customer"){
        newParams.customerID = id
        newParams.scope = determineScope(options.scopeOrder,newParams.country,newParams.customerID,newParams.deviceTypes,newParams.devicesWithSerial)
        return newParams;
    }else if (params.scope === "device"){
        newParams.devicesWithSerial = Format.DeviceWithSerialByCADID(deviceObjects,id)
        newParams.customerID = Format.customerIDByDeviceWithSerial(deviceObjects,newParams.devicesWithSerial[0]);
        
        newParams.scope = determineScope(options.scopeOrder,newParams.country,newParams.customerID,newParams.deviceTypes,newParams.devicesWithSerial)
        return newParams;
    }else if (params.scope === "deviceType"){
        newParams.deviceTypes = [Number(id)]
        newParams.scope = determineScope(options.scopeOrder,newParams.country,newParams.customerID,newParams.deviceTypes,newParams.devicesWithSerial)
        return newParams;
    }
    return null;
}